// Register custom block styles
wp.blocks.registerBlockStyle('core/image', {
	name: 'svg-masked-circle',
	label: 'Masked Circle',
	isDefault: false // Set to true if you want this as the default style
});

wp.blocks.registerBlockStyle('core/image', {
	name: 'svg-masked-heart',
	label: 'Masked Heart',
	isDefault: false // Set to true if you want this as the default style
});

wp.blocks.registerBlockStyle('core/image', {
	name: 'svg-masked-star',
	label: 'Masked Star',
	isDefault: false // Set to true if you want this as the default style
});

wp.blocks.registerBlockStyle('core/media-text', {
		name: 'dotted-grid',
		label: 'Dotted',
		isDefault: false // Set to true if you want this as the default style
});

wp.blocks.registerBlockStyle('core/paragraph', {
		name: 'box-shadow',
		label: 'Box',
		isDefault: false // Set to true if you want this as the default style
});

wp.blocks.registerBlockStyle('core/group', {
	name: 'box-shadow',
	label: 'Box',
		isDefault: false // Set to true if you want this as the default style
});

wp.blocks.registerBlockStyle('core/cover', {
	name: 'box-below',
	label: 'Box unten',
		isDefault: false // Set to true if you want this as the default style
});

// Unregister unused block styles
wp.domReady(function() {
	console.log("remove styles");
		// Array of block styles to unregister
		var stylesToRemove = [
				{ block: 'core/button', style: 'circular' },
				{ block: 'core/button', style: 'shadow' },
				{ block: 'core/button', style: '3D' },

		];

		// Loop through the array and unregister each style
		stylesToRemove.forEach(function(style) {
				wp.blocks.unregisterBlockStyle(style.block, style.style);
		});
});
